
import { TranslationRecord } from '../../types';

export const gallery: TranslationRecord = {
  // Gallery tabs
  all: 'All',
  living: 'Living Area',
  bedroom: 'Bedroom', 
  bathroom: 'Bathroom',
  kitchen: 'Kitchen',
  dining: 'Dining Area',
  exterior: 'Exterior',
  
  // Gallery actions
  viewImage: 'View Image',
  closeGallery: 'Close gallery',
  previousImage: 'Previous image',
  nextImage: 'Next image',
  
  // Error states
  errorLoadingGallery: 'Error Loading Gallery',
  galleryErrorMessage: 'We encountered an issue loading the suite gallery. Please try again.',
  
  // Booking states
  bookingRedirect: 'Redirecting to Booking',
  bookingRedirectMessage: 'Opening booking system in a new tab',
  bookingError: 'Booking Error',
  bookingErrorMessage: 'Unable to open booking system. Please try again.',
};
